import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="21" height="22" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.40625 0.900391H14.1797C14.5696 0.900473 14.9419 1.05184 15.2197 1.31934L15.333 1.44141L17.6455 4.22559L19.2393 6.52734C19.4128 6.7781 19.5058 7.07591 19.5059 7.38086V21.5996C19.5059 22.428 18.8343 23.0996 18.0059 23.0996H2.40625C1.57782 23.0996 0.90625 22.428 0.90625 21.5996V2.40039C0.90625 1.57196 1.57782 0.900391 2.40625 0.900391Z"
      stroke="#C9C8E6"
      strokeWidth="1.8"
    />
    <path
      d="M12.0059 8.58952L9.60586 10.8M9.60586 10.8L7.20586 8.58952M9.60586 10.8L9.60586 4.80005"
      stroke="#7876C1"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2989 17.1301H9.85742V20.2054H10.1976C10.648 20.2054 10.9784 20.0706 11.1886 19.809C11.3988 19.5476 11.5039 19.1458 11.5039 18.6077C11.5039 18.1047 11.4044 17.7344 11.2055 17.4917C11.0065 17.249 10.7043 17.1301 10.2989 17.1301Z"
      fill="#7876C1"
    />
    <path
      d="M18.7706 13.1998H1.73114C0.775079 13.1998 0 13.9749 0 14.931V22.1751C0 23.1312 0.775079 23.9063 1.73114 23.9063H18.7706C19.7267 23.9063 20.5017 23.1312 20.5017 22.1751V14.931C20.5017 13.9749 19.7267 13.1998 18.7706 13.1998ZM6.96227 19.084C6.60065 19.4181 6.08702 19.5781 5.4214 19.5781H5.01153V21.4005H3.53085V15.9334H5.4214C6.11453 15.9334 6.6351 16.0805 6.98295 16.3832C7.33074 16.686 7.50472 17.1109 7.50472 17.6688C7.50472 18.282 7.3239 18.7499 6.96227 19.084ZM12.2813 20.6634C11.777 21.1588 11.0682 21.4005 10.1548 21.4005H8.37154V15.9334H10.2787C11.1595 15.9334 11.8396 16.1543 12.3189 16.6047C12.798 17.0551 13.0377 17.7006 13.0377 18.5515C13.0377 19.4673 12.7856 20.1679 12.2813 20.6634ZM17.2556 17.1293H15.4902V18.1544H17.1417V19.3503H15.4902V21.4005H14.0095V15.9334H17.2556V17.1293Z"
      fill="#7876C1"
    />
    <path
      d="M5.39172 17.1301H5.01562V18.383H5.27907C5.5018 18.383 5.67886 18.3211 5.81024 18.1959C5.94162 18.0708 6.00728 17.902 6.00728 17.6817C6.00728 17.3115 5.80209 17.1301 5.39172 17.1301Z"
      fill="#7876C1"
    />
  </svg>
);

const DownloadIcon = (props) => <Icon component={svg} {...props} />;

export default DownloadIcon;
